import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { FacadeService } from 'src/app/core/services/facade.service';
import {
	CompetencesElementaires,
	hasEmployeeSkill
} from 'src/app/shared/enums/competence.enum';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Authority } from 'src/app/shared/models/security/authority';
import { User } from 'src/app/shared/models/security/user';

@Component({
	selector: 'app-meeting-form',
	templateUrl: './meeting-form.component.html',
	styleUrls: ['./meeting-form.component.scss']
})
export class MeetingFormComponent implements OnInit {
	/**
	 * La réunion
	 */
	@Input() synchronizedEvent: Mission;

	/**
	 * Formulaire angular
	 */
	@Input() meetingForm: FormGroup;

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * La date de la réunion, définit par le bsModel dans le HTML
	 * On ne peut pas utiliser startDate/endDate sinon à chaque modif du bsModel l'heure et les minutes sont reset()
	 */
	date: Date;

	/**
	 * Sélection des participants à la réunion
	 */
	user: User;
	Authority = Authority;
	listEmployee: Employee[];
	selectedParticipant: string = '';
	listEmployeeMapped = []; // list pour le typeahead sous forme {name:nom_employee,object:employee}

	isSSIAD =
		(JSON.parse(sessionStorage.getItem('USER')) as User)?.employee
			?.serviceCenter?.type === 3
			? true
			: false;

	constructor(private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();

		this.facade.employeeService
			.getAllActiveEmployees()
			.subscribe((allEmployees) => {
				this.listEmployee = allEmployees;

				if (this.isSSIAD) {
					this.listEmployee = this.listEmployee.filter((employee) => {
						return (
							hasEmployeeSkill(employee, CompetencesElementaires.INFIRMIER) ||
							hasEmployeeSkill(employee, CompetencesElementaires.AIDESOIGNANT)
						);
					});
				}

				this.listEmployeeMapped = this.listEmployee.flatMap((e) => {
					return { name: e.firstName + ' ' + e.lastName, object: e };
				});
			});
	}

	typeaheadEmployeeOnSelectForReunion(event: TypeaheadMatch): void {
		const empToInsert = event.item.object as Employee;
		if (
			this.synchronizedEvent.attendees.findIndex(
				(emp) => emp.id === empToInsert.id
			) === -1
		) {
			this.synchronizedEvent.attendees.push(empToInsert);
		}
		this.selectedParticipant = '';
	}

	selectAllParticipants() {
		this.synchronizedEvent.attendees = this.listEmployee;
	}

	resetParticipants() {
		this.synchronizedEvent.attendees = [...this.synchronizedEvent.attendees];
	}

	removeParticipant(p: Employee) {
		this.synchronizedEvent.attendees = this.synchronizedEvent.attendees.filter(
			(emp) => emp.id !== p.id
		);
	}

	get notes() {
		return this.meetingForm.get('notes');
	}
}
